var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.969 0.000212151C18.8108 0.00410828 18.6536 0.0252332 18.5 0.0632124L2.25 4.34321C1.60769 4.51327 1.03926 4.89014 0.632576 5.41558C0.225888 5.94102 0.00357716 6.58578 0 7.25021V21.0002C0 22.6452 1.355 24.0002 3 24.0002H21C22.645 24.0002 24 22.6452 24 21.0002V8.00021C24 6.35521 22.645 5.00021 21 5.00021H7.625L19 2.00021V4.00021H21V2.00021C21 0.875212 20.043 -0.0157878 18.969 0.000212151ZM3 7.00021H21C21.566 7.00021 22 7.43421 22 8.00021V21.0002C22 21.5662 21.566 22.0002 21 22.0002H3C2.434 22.0002 2 21.5662 2 21.0002V8.00021C2 7.43421 2.434 7.00021 3 7.00021ZM18.5 13.0002C18.1022 13.0002 17.7206 13.1582 17.4393 13.4396C17.158 13.7209 17 14.1024 17 14.5002C17 14.898 17.158 15.2796 17.4393 15.5609C17.7206 15.8422 18.1022 16.0002 18.5 16.0002C18.8978 16.0002 19.2794 15.8422 19.5607 15.5609C19.842 15.2796 20 14.898 20 14.5002C20 14.1024 19.842 13.7209 19.5607 13.4396C19.2794 13.1582 18.8978 13.0002 18.5 13.0002Z",
    fill: "#000FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletBlue);
export default __webpack_public_path__ + "static/media/wallet-blue.a852d3603118f0a57d9a2473d0dcd314.svg";
export { ForwardRef as ReactComponent };